import { render, staticRenderFns } from "./BearbeiteBusinessUnit.vue?vue&type=template&id=0c020ba5&"
import script from "./BearbeiteBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./BearbeiteBusinessUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports